var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * @fileoverview added by tsickle
 * Generated from: util/base-object.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { isFunction } from 'lodash-es';
/**
 * @record
 */
function BaseObject() { }
if (false) {
    /** @type {?} */
    BaseObject.prototype.create;
    /** @type {?} */
    BaseObject.prototype.extend;
    /** @type {?|undefined} */
    BaseObject.prototype.construct;
}
/** @type {?} */
var baseObject = {
    create: /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /** @type {?} */
        var obj = Object.create(this);
        if (isFunction(obj.construct)) {
            obj.construct.apply(obj, __spread(args));
        }
        return obj;
    },
    extend: /**
     * @param {...?} parents
     * @return {?}
     */
    function () {
        var parents = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parents[_i] = arguments[_i];
        }
        /** @type {?} */
        var obj = Object.create(this);
        if (parents.length) {
            obj = Object.assign.apply(Object, __spread([obj], parents));
        }
        return obj;
    }
};
export { baseObject };
